import { setAppType } from "@funded-here-interface/common/src/constant/appType";
import ErrorBoundary from "@funded-here-interface/common/src/dashboard/components/ErrorBoundry";
import { setupBlobErrorNormalizer } from "@funded-here-interface/common/src/Utils/axiosBlobErrorInterceptor";
import { setupUnauthorizedInterceptor } from "@funded-here-interface/common/src/Utils/axiosUnauthorizedInterceptor";

import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "mantine-react-table/styles.css";
import { MantineProvider } from "@mantine/core";
import { emotionTransform, MantineEmotionProvider } from "@mantine/emotion";

import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { handleUnauthorizedRedirect } from "./reactQuery";

setAppType("admin");
// Order is load-bearing. The blob normaliser must be FIRST so the 401
// handlers below can read `data.code` on responseType:"blob" errors at all —
// admin has 22 such CSV/PDF download services; the generic 401 interceptor
// must register before render so it stays AHEAD of the session-kill
// interceptor (SessionInterceptorProvider mount effect) in axios's chain.
setupBlobErrorNormalizer();
setupUnauthorizedInterceptor(handleUnauthorizedRedirect);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <MantineProvider stylesTransform={emotionTransform}>
      <MantineEmotionProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </MantineEmotionProvider>
    </MantineProvider>
  </React.StrictMode>,
);
